import React, { useState } from 'react';
import {
  Box,
  Button,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Chip,
  Divider
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import PublicIcon from '@mui/icons-material/Public';
import PersonIcon from '@mui/icons-material/Person';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import GavelIcon from '@mui/icons-material/Gavel';
import { ViewMode, useBandView } from '../../contexts/BandViewContext';

const viewOptions = [
  { 
    value: 'admin', 
    label: 'Admin View',
    icon: <AdminPanelSettingsIcon fontSize="small" />,
  },
  { 
    value: 'artist', 
    label: 'Artist View',
    icon: <PersonIcon fontSize="small" />,
  },
  { 
    value: 'public', 
    label: 'Public View',
    icon: <PublicIcon fontSize="small" />,
  },
  { 
    value: 'strand', 
    label: 'Strand View',
    icon: <AccountTreeIcon fontSize="small" />,
  },
  { 
    value: 'judge', 
    label: 'Judge View',
    icon: <GavelIcon fontSize="small" />,
  }
];

const AdminViewSwitcher = () => {
  const { viewMode, setViewMode, currentUser } = useBandView();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  
  // Show switcher only if user is admin
  if (!currentUser || (currentUser.role !== 'admin' && currentUser.role !== 'gm')) return null;
  
  const currentView = viewOptions.find(option => option.value === viewMode);
  
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  
  const handleClose = () => {
    setAnchorEl(null);
  };
  
  const handleViewChange = (value: ViewMode) => {
    setViewMode(value);
    handleClose();
  };
  
  return (
    <Box sx={{ position: 'fixed', top: 80, right: 24, zIndex: 1100 }}>
      <Button
        variant="outlined"
        size="small"
        onClick={handleClick}
        startIcon={currentView?.icon}
        endIcon={<KeyboardArrowDownIcon />}
        sx={{ 
          bgcolor: 'background.paper',
          '&:hover': { bgcolor: 'background.paper' }
        }}
      >
        {currentView?.label}
      </Button>
      
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {viewOptions.map((option) => (
          <MenuItem
            key={option.value}
            onClick={() => handleViewChange(option.value as ViewMode)}
            selected={option.value === viewMode}
          >
            <ListItemIcon>
              {option.icon}
            </ListItemIcon>
            <ListItemText primary={option.label} />
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default AdminViewSwitcher;